import { Form } from "@/organisms/Form/Form"

export const HiddenFields: React.FC<{ name: number }> = ({ name }) => (
  <>
    {[
      "disabled",
      "focusId",
      "key",
      "label",
      "title",
      "value",
      "selectedValue"
    ].map((field) => (
      <Form.Item key={field} name={[name, field]} hidden noStyle />
    ))}
  </>
)
